<template>
<v-app :style="{ backgroundColor: `${APP_COLOR}` }">
	<v-progress-linear
		v-if="loading"
		indeterminate
		color="primary"
	/>
	<NavBar />
	<v-main
		v-if="!loading"
		:style="{ backgroundColor: 'white' }"
	>
		<router-view />
	</v-main>
	<NotifySnackbar />
</v-app>
</template>

<script>
import NavBar from '@/components/layout/NavBar.vue'
import NotifySnackbar from '@/components/general/NotifySnackbar.vue'
import { HTTP } from './services/http'
import { Log } from './modules/util/log'
import { Settings } from '@/settings'
import { Notify } from '@/modules/util/notify'
import './modules/util/log'
import { UserService } from './services/user-service'

export default {
	name: 'App',
	components: {
		NavBar,
		NotifySnackbar,
	},
	data() {
		return {
			loading: true,
			APP_COLOR: Settings.APP_COLOR,
		}
	},
	async mounted() {
		const success = await Settings.init()
		if (!success) {
			Notify.error('Failed to load site config')
			return
		}

		HTTP.initCacheRetry()
		Log.initLogUpload()

		this.loading = false
		document.getElementById('app').dataset.mounted = 'true'

		// if loaded on login page, redirect to home
		if (UserService.hasAuth() && this.$route.path === '/login') {
			this.$router.push({ name: 'home' })
		}
	},
	unmounted() {
		HTTP.stopCacheRetry()
		Log.stopLogUpload()
	},
}
</script>

<style>
html,
body {
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  height: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html, body, #app {
  overscroll-behavior: none;  /* prevent scroll chaining / rubber-band */
  -webkit-overflow-scrolling: auto; /* disables iOS momentum */
  touch-action: pan-x pan-y;
}
</style>
